import { LinearProgress } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";

export default withStyles(theme => ({
  colorPrimary: {
    backgroundColor: "#DDD"
  },
  root: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    height: theme.spacing(0.75)
  }
}))(LinearProgress);
